import { useEffect } from 'react';

/** Sets `document.title` while mounted (or while `title` is non-null) and puts the previous title back on cleanup. */
export function useDocumentTitle(title: string | null): void {
  useEffect(() => {
    if (!title) return;
    const before = document.title;
    document.title = title;
    return () => {
      document.title = before;
    };
  }, [title]);
}
